module.exports = __webpack_public_path__ + "img/2-6.cbfdb004.png";